import { AppointmentRepository } from '@/core/appointment/domain/AppointmentRepository.ts'

type CancelAppointmentUseCaseDependencies = { appointmentRepository: AppointmentRepository }

export class CancelAppointmentUseCase {
  private readonly appointmentRepository: AppointmentRepository
  constructor({ appointmentRepository }: CancelAppointmentUseCaseDependencies) {
    this.appointmentRepository = appointmentRepository
  }

  execute = (hostId: string, enterpriseId: string, appointmentId: string): Promise<void> => {
    return this.appointmentRepository.cancelAppointment(hostId, enterpriseId, appointmentId)
  }
}
